<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import { onMount } from "svelte"
  import { push } from "svelte-spa-router"
  import notify from "../../../../Script/notify"
  import { postRequest } from "../../../../Script/apiMethods"

  export let code = ""

  let authInput1
  let authInput2
  let authInput3
  let authInput4
  let authInput5
  let authInput6

  /**
   * @type {emailerrnotify} - Authentication related error codes
   */
  let emailerrnotify = {
    close() {},
  }

  onMount(() => {
    authInput1.focus()
  })

  $: if (!code && authInput1) authInput1.focus()

  const verify = async (e) => {
    try {
      code = e.target[0].value + e.target[1].value + e.target[2].value + e.target[3].value + e.target[4].value + e.target[5].value
      const { verify } = await postRequest(
        `/api/swagger/v2/2fa/authenticator-verify`,
        { otp: code },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )
      if (!verify) throw "Authentication code is incorrect"

      push("/settings/integration/home")
      notify.success("Authentication code successfully validated.")

      code = ""
      authInput1.value = ""
      authInput2.value = ""
      authInput3.value = ""
      authInput4.value = ""
      authInput5.value = ""
      authInput6.value = ""
    } catch (error) {
      // Show an error notification
      emailerrnotify.close()
      const info = "PAGE: Validate 2FA Integration\nEVENT: While validating 2F Authentication code"
      emailerrnotify = notify.danger(error, info)
    }
  }

  const pasteValue = (value) => {
    let pastedValue = value
    authInput1.value = pastedValue.slice(0, 1)
    authInput2.value = pastedValue.slice(1, 2)
    authInput3.value = pastedValue.slice(2, 3)
    authInput4.value = pastedValue.slice(3, 4)
    authInput5.value = pastedValue.slice(4, 5)
    authInput6.value = pastedValue.slice(5, 6)
  }
</script>

<form on:submit|preventDefault|stopPropagation={verify} class="w-full space-y-6 rounded-md pt-3 sm:space-y-20">
  <div class="flex gap-3">
    <input
      bind:this={authInput1}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }
        if (authInput1.value.length <= 1) {
          authInput1.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput2.focus()
        } else {
          authInput1.value = e.target.value.slice(1, 2)
          authInput2.focus()
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      required
      type="number"
      name="authInput1"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
    <input
      bind:this={authInput2}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }

        if (authInput2.value.length <= 1) {
          authInput2.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput3.focus()
        } else {
          authInput2.value = e.target.value.slice(1, 2)
          authInput3.focus()
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      on:keydown={(e) => {
        if (e.key == "Backspace") {
          // code = code.slice(0, code.length - 1)
          e.preventDefault()
          authInput1.focus()
          e.target.value = ""
        }
      }}
      required
      type="number"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
    <input
      bind:this={authInput3}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }

        if (authInput3.value.length <= 1) {
          authInput3.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput4.focus()
        } else {
          authInput3.value = e.target.value.slice(1, 2)
          authInput4.focus()
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      on:keydown={(e) => {
        if (e.key == "Backspace") {
          code = code.slice(0, code.length - 1)
          e.preventDefault()
          authInput2.focus()
          e.target.value = ""
        }
      }}
      required
      type="number"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
    <input
      bind:this={authInput4}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }
        if (authInput4.value.length <= 1) {
          authInput4.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput5.focus()
        } else {
          authInput4.value = e.target.value.slice(1, 2)
          authInput5.focus()
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      on:keydown={(e) => {
        if (e.key == "Backspace") {
          e.preventDefault()
          code = code.slice(0, code.length - 1)
          authInput3.focus()
          e.target.value = ""
        }
      }}
      required
      type="number"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
    <input
      bind:this={authInput5}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }
        if (authInput5.value.length <= 1) {
          authInput5.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput6.focus()
        } else {
          authInput5.value = e.target.value.slice(1, 2)
          authInput6.focus()
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      on:keydown={(e) => {
        if (e.key == "Backspace") {
          e.preventDefault()
          code = code.slice(0, code.length - 1)
          authInput4.focus()
          e.target.value = ""
        }
      }}
      required
      type="number"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
    <input
      bind:this={authInput6}
      on:input={(e) => {
        if (e.inputType == "insertFromPaste") {
          pasteValue(e.target.value)
        }
        if (authInput6.value.length <= 1) {
          authInput6.value = e.target.value.slice(0, 1)
          if (e.inputType == "insertFromPaste") authInput6.focus()
          else authInput6.focus()
        } else {
          authInput6.value = e.target.value.slice(1, 2)
        }
        if (code.length < 6) code = authInput1.value + authInput2.value + authInput3.value + authInput4.value + authInput5.value + authInput6.value
      }}
      on:keypress={(e) => {
        if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
      }}
      on:keydown={(e) => {
        if (e.key == "Backspace") {
          e.preventDefault()
          code = code.slice(0, code.length - 1)
          authInput5.focus()
          e.target.value = ""
        }
      }}
      required
      type="number"
      maxlength="1"
      class="h-9 w-9 rounded-md border border-[#a0a1a580] bg-transparent px-3 font-mono text-lg font-semibold text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
    />
  </div>
  <div class="flex items-center gap-3 sm:justify-end">
    <button on:click type="button" class="flex h-9 items-center justify-center rounded-md bg-blue-500 px-8 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300">
      <i class="fa-solid fa-qrcode" />
      &nbsp;&nbsp;
      <span class="hidden mobile:block">Scan QRCode</span>
      <span class="block mobile:hidden">Scan</span>
    </button>

    <button disabled={!code} type="submit" class="flex h-9 items-center justify-center rounded-md bg-green-500 px-8 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300">
      <i class="fa-solid fa-check-double" />
      &nbsp;&nbsp;Validate
    </button>
  </div>
</form>
